import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { ProfileService } from '../../../services/profile/profile.service'
import { VocabularyService } from '../../../services/vocabulary/vocabulary.service'

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.page.html',
  styleUrls: ['./show-terms.page.scss'],
})
export class ShowTermsPage implements OnInit {

  constructor(private modalController: ModalController,
              private profileService: ProfileService,
              public vS:VocabularyService) { };


  ngOnInit() {

  }

  public accept() {
    this.profileService.ackTerms();
    this.modalController.dismiss();
  }

}
